export const CHANGE_WINDOW_MODE = 'CHANGE_WINDOW_MODE';

export const changeWindowMode = ( windowMode: string ) => ({
    type: CHANGE_WINDOW_MODE,
    payload: { windowMode },
});